'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.classnames = function () {
  for (var e = [], t = 0; t < arguments.length; t++) e[t] = arguments[t];
  for (var r = '', n = new Set(), s = 0, a = e.join(' ').split(' '); s < a.length; s++) {
    var o = a[s];
    '' === o || n.has(o) || (n.add(o), r.length > 0 && (r += ' '), r += o);
  }
  return r;
};